import { createContext, type ReactNode, useCallback, useContext, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { Icon } from './Icon';

// Notifikasi singkat — kartu tema di tengah atas layar (HP & desktop): <div id="toast" class="toast show [err]">,
// 2,6 dtk (error 5 dtk). Selalu di atas modal.
type ToastFn = (msg: string, err?: boolean) => void;
const Ctx = createContext<ToastFn>(() => {});
export const useToast = () => useContext(Ctx);

export function ToastProvider({ children }: { children: ReactNode }) {
  const [s, setS] = useState<{ msg: string; err: boolean; show: boolean }>({ msg: '', err: false, show: false });
  const timer = useRef<ReturnType<typeof setTimeout>>(undefined);
  const toast = useCallback<ToastFn>((msg, err = false) => {
    setS({ msg, err, show: true });
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setS((x) => ({ ...x, show: false })), err ? 5000 : 2600);
  }, []);
  const root = document.getElementById('toastRoot');
  return (
    <Ctx.Provider value={toast}>
      {children}
      {root
        ? createPortal(
            <div
              id="toast"
              className={`toast${s.show ? ' show' : ''}${s.err ? ' err' : ''}`}
              role={s.err ? 'alert' : 'status'}
              aria-live={s.err ? 'assertive' : 'polite'}
            >
              <span className="toast-ic">
                <Icon n={s.err ? 'alert' : 'check'} />
              </span>
              <span className="toast-msg">{s.msg}</span>
            </div>,
            root,
          )
        : null}
    </Ctx.Provider>
  );
}
